import React, { useState } from 'react'
import { Form, Input, Button, Row, Typography, message, Flex } from 'antd';
import { useApp } from '../../context/app-context';
import { UserOutlined } from '@ant-design/icons';
import { useNavigate, Link } from "react-router-dom"
import { forgotPassword } from '../../services/AuthService';
import { LOGIN_VERSION } from '../../Constants';
import ReCAPTCHA from 'react-google-recaptcha';
import './Auth.css';

const { Title, Paragraph } = Typography;

export const ForgotPassword = ({version}, ...props) => {
    const [isVerified, setIsVerified] = useState(false);
    const {state: {auth}, dispatch} = useApp();
    var formRef = React.createRef();
    const navigate = useNavigate();



    const onChange = (value) => {
        setIsVerified(true);
    };

    const onFinish = (data) => {
        forgotPassword(data).then(function (response) {
            if( response.success) {
                message.success(response.message, 10);
                formRef.current.resetFields();
                navigate('/')
            }
        })
    };

    return (
        <>
            <Row justify="center">
                <Form
                    name="forgot-password"
                    className="form-container"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    ref={formRef}
                    autoComplete='off'
                >
                    <Title level={1}>Forgot password?</Title>
                    <Paragraph>Enter your username and the email address that you used to register. If it matches our records, We'll send you an email a one-time use password.</Paragraph>
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: "Username is required" }]}
                    >
                        <Input 
                            prefix={<UserOutlined/>}
                            placeholder="Username"
                        />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        rules={[{ required: true, message: "Please enter valid email address" }]}
                    >
                        <Input 
                            prefix={<UserOutlined/>} 
                            placeholder="Email address" 
                            type='email'
                        />
                    </Form.Item>

                    { version === LOGIN_VERSION.cloud1x && 
                        <>
                            <Form.Item
                                name="captcha"
                                rules={[{ required: true, message: "Captcha is required" }]}
                            >
                                <ReCAPTCHA
                                        sitekey="6Lc6xX0pAAAAAHsAhLZd64kACHGhkPMSUmmAeqv-"
                                        onChange={onChange}
                                />

                            </Form.Item>
                        </>
                    }

                    <Flex vertical justify='center' gap='middle'>
                        <Button  
                            type="primary" 
                            block 
                            htmlType="submit" 
                            className="login-form-button btn-block"
                        >
                            Submit
                        </Button>
                        <Link to='../'>
                            <Button block type='link' >Back to Login</Button>
                        </Link>
                    </Flex>
                </Form>
            </Row>
        </>
    )
}
